<div [@slide]="sideBarService.isSideBarCollapsed() ? 'closed' : 'open'" class="sidebar" data-cy="sidebar-container">
  <div class="w-100 d-flex flex-column h-100">
    <div class="sidebar__body px-2 py-4">
      <!-- Logo section -->
      <div class="login-header mb-3">
        <img src="assets/box-icon.png" alt="KlausurenKiste Logo" class="login-header-logo">
        <h2 class="login-header-title">
          Klausuren<span class="title-highlight">KI</span>ste
        </h2>
      </div>

      <!-- Login button for non-authenticated users -->
      <div class="nav-item mb-3" *ngIf="!authService.isAuthenticated()">
        <button [routerLink]="'/auth/login'" class="btn btn-primary w-100" type="button">
          <i class="bi bi-box-arrow-in-right"></i> Login
        </button>
      </div>

      <!-- Kanzlei-Block für kanzlei_admin oder Org-Mitglieder -->
      <div *ngIf="authService.isKanzleiAdmin() || billingState.orgLicense()?.orgName" class="kanzlei-block mb-3">
        <div class="kanzlei-block__header">
          <i class="bi bi-building"></i>
          <span class="kanzlei-block__name">{{ billingState.orgLicense()?.orgName || 'Kanzlei' }}</span>
        </div>
        <!-- Portal-Button nur für kanzlei_admin, da /kanzlei nur für Admins sinnvoll nutzbar ist -->
        <a *ngIf="authService.isKanzleiAdmin()" routerLink="/kanzlei" class="kanzlei-block__portal-btn">
          <i class="bi bi-grid-3x3-gap me-1"></i> Kanzleiportal öffnen
        </a>
      </div>

      <hr class="sidebar-divider" *ngIf="authService.isKanzleiAdmin() || billingState.orgLicense()?.orgName">

      <button [routerLink]="''" [queryParams]="{view: 'public'}" class="btn w-100 mb-2 d-flex align-items-center"
        type="button">
        <i class="bi bi-grid me-2" id="collapse-cases-ico"></i>
        <span>Fälle entdecken</span>
      </button>

      <button routerLink="/create-case-editor" class="btn w-100 mb-2 d-flex align-items-center" type="button">
        <i class="bi bi-plus-circle me-2" id="create-case-ico"></i>
        <span>Fall erstellen</span>
      </button>

      <!-- Benchmark Navigation -->
      <button *ngIf="authService.isAdmin()" routerLink="/benchmark/list"
        class="btn w-100 mb-2 d-flex align-items-center btn-outline-secondary" type="button">
        <i class="bi bi-speedometer2 me-2"></i>
        <span>Benchmark Runs</span>
      </button>

      <!-- Abgaben Dashboard -->
      <button *ngIf="authService.isGrader()" routerLink="/pilot/dashboard"
        class="btn w-100 mb-2 d-flex align-items-center btn-outline-secondary" type="button">
        <i class="bi bi-inbox me-2"></i>
        <span>Kursverwaltung</span>
      </button>

      <!-- Autor:innen Dashboard -->
      <button *ngIf="authService.isAuthor()" routerLink="/author/dashboard"
        class="btn w-100 mb-2 d-flex align-items-center btn-outline-secondary" type="button">
        <i class="bi bi-pen me-2"></i>
        <span>Autor:innenprogramm</span>
      </button>

      <!-- Meine Kurse (for users with assigned courses) -->
      <button *ngIf="authService.user()?.assigned_courses?.length" routerLink="/student/courses"
        class="btn w-100 mb-2 d-flex align-items-center btn-outline-secondary" type="button">
        <i class="bi bi-book me-2"></i>
        <span>Meine Kurse</span>
      </button>

      <!-- Credit Display -->
      <div class="sidebar-credits" *ngIf="billingState.entitlements()" (click)="openBilling()" title="Credits verwalten">
        <div class="sidebar-credits__item">
          <i class="bi bi-coin"></i>
          <div class="sidebar-credits__info">
            <span class="sidebar-credits__value">{{ billingState.submissionCredits() }}</span>
            <span class="sidebar-credits__label">Abgaben</span>
          </div>
        </div>
        <div class="sidebar-credits__divider"></div>
        <div class="sidebar-credits__item">
          <i class="bi bi-journal-plus"></i>
          <div class="sidebar-credits__info">
            <span class="sidebar-credits__value">{{ billingState.caseCreationCredits() }}</span>
            <span class="sidebar-credits__label">Fälle</span>
          </div>
        </div>
      </div>

      <div class="requests px-2" #requestsContainer>
        <div class="vstack col 12">
          <!-- Loading state -->
          <div class="d-flex align-items-center justify-content-center py-3" *ngIf="sideBarService.isLoading()">
            <div class="spinner-border text-info" role="status"></div>
          </div>

          <!-- Error state with retry -->
          <div class="alert alert-danger d-flex justify-content-between align-items-center" role="alert"
            *ngIf="sideBarService.errorMessage()">
            <span>{{ sideBarService.errorMessage() }}</span>
            <button class="btn btn-sm btn-outline-light" (click)="sideBarService.updateRequests()">Erneut
              versuchen</button>
          </div>

          <!-- Empty state -->
          <div class="text-muted text-center py-2"
            *ngIf="!sideBarService.isLoading() && !sideBarService.errorMessage() && !sortedRequests().length">
            Noch keine Anfragen vorhanden.
          </div>

          <!-- For each request item in the sidebar -->
          <div class="sidebar-item" *ngFor="let request of sortedRequests()">
            <!-- One flex row: left = clickable title; right = X button -->
            <div class="d-flex align-items-center justify-content-between w-100">

              <!-- Left: A button that loads the request on click -->
              <button class="btn btn-sm text-start text-truncate flex-grow-1 me-2" [title]="request.case.name"
                (click)="onRequestClick(request)" [class.selected]="sideBarService.activeRequestId() === request.id">
                <!-- Status icon -->
                <i class="bi bi-circle-fill" *ngIf="request.status === 0"></i>
                <i class="bi bi-check-circle-fill" *ngIf="request.status > 0 && request.status < 88"></i>
                <i class="bi bi-check-circle-fill text-success"
                  *ngIf="request.status === 88 || request.status === 90"></i>
                <i class="bi bi-hourglass-split text-info" *ngIf="request.status === 89"></i>

                <!-- Truncated case name -->
                <span class="ms-2 text-truncate">
                  {{ request.display_name || request.case.name }}
                  <i class="bi bi-pencil-square edit-icon ms-1" (click)="renameCase($event, request)"
                    [title]="'Umbenennen ' + request.case.name"></i>
                </span>

                <!-- Date below the title -->
                <small class="text-muted d-block">
                  {{ request.created ? (request.created | date:'short') : 'No date' }}
                </small>
              </button>

              <!-- Right: Dropdown menu for options -->
              <div dropdown placement="bottom left" container="body">
                <button dropdownToggle type="button" class="btn btn-sm p-0 dropdown-toggle no-arrow"
                  [style.width.px]="24" [title]="'Options for ' + request.case.name">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                  <li role="menuitem">
                    <button class="dropdown-item" (click)="renameCase($event, request)">
                      <i class="bi bi-pencil me-2"></i>Umbenennen
                    </button>
                  </li>
                  <li *ngIf="authService.isAdmin()" role="menuitem">
                    <button class="dropdown-item" [disabled]="!request.id" (click)="downloadCsvOverview(request.id)">
                      <i class="bi bi-download me-2"></i>Download Process Request Overview
                    </button>
                  </li>
                  <li role="menuitem">
                    <button class="dropdown-item text-danger" (click)="deleteRequest($event, request.id)">
                      <i class="bi bi-trash me-2"></i>Löschen
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- User profile icon at the bottom -->
    <div class="px-2 py-3 d-flex align-items-center justify-content-between sidebar__footer" *ngIf="authService.isAuthenticated()">
      <div type="button" placement="top" [isOpen]="isOpenEditorSwitcher()" [outsideClick]="true"
        [popover]="userPopoverContent" class="user-profile-trigger">
        @if (userCustomAvatarUrl()) {
        <img [src]="userCustomAvatarUrl()" alt="User Avatar" class="rounded-circle sidebar__profile-avatar">
        } @else {
        <div class="rounded-circle sidebar__profile-avatar initials-avatar-bg">
          <span>{{ userInitials() }}</span>
        </div>
        }
      </div>

      <!-- Theme Toggle -->
      <app-theme-toggle></app-theme-toggle>
    </div>
  </div>

  <button class="toggle-btn" data-cy="sidebar-toggle-button" (mouseenter)="mouseOver = true"
    (mouseleave)="mouseOver = false" (click)="sideBarService.toggle()">
    <i [ngClass]="getSlideBTNClass()" class="slide-icon"></i>
  </button>
</div>

<ng-template #userPopoverContent>
  <div class="d-flex flex-column gap-2">
    @if(authService.user(); as user) {
    <div class="sidebar__profile-info">
      <div class="sidebar__profile-name fw-bold">{{ user.username }}</div>
      <div class="sidebar__profile-email text-muted">{{ user.email }}</div>
    </div>
    }

    <!-- Account Einstellungen -->
    <button type="button" class="btn btn-sm d-flex align-items-center" [routerLink]="'/account/settings'">
      <i class="bi bi-gear me-2"></i>
      Account Einstellungen
    </button>

    <!-- Impressum button -->
    <button type="button" class="btn btn-sm d-flex align-items-center" [routerLink]="'/impressum'">
      <i class="bi bi-file-earmark-text me-2"></i>
      Impressum
    </button>

    <!-- Datenschutzerklärung button -->
    <button type="button" class="btn btn-sm d-flex align-items-center" [routerLink]="'/datenschutzerklaerung'">
      <i class="bi bi-shield-lock me-2"></i>
      Datenschutzerklärung
    </button>

    <!-- Nutzungsbedingungen button -->
    <button type="button" class="btn btn-sm d-flex align-items-center" [routerLink]="'/nutzungsbedingungen'">
      <i class="bi bi-file-text me-2"></i>
      Nutzungsbedingungen
    </button>

    <!-- Widerrufsbelehrung button -->
    <button type="button" class="btn btn-sm d-flex align-items-center" [routerLink]="'/widerrufsbelehrung'">
      <i class="bi bi-arrow-return-left me-2"></i>
      Widerrufsbelehrung
    </button>

    <button id="logout-btn" type="button" class="btn btn-sm d-flex align-items-center" (click)="logout()">
      <i class="bi bi-box-arrow-left me-2"></i>
      Logout
    </button>
  </div>
</ng-template>